<template>
  <confirmation-modal :is-open="isOpen">
    <template slot="header">{{ header }}</template>
    {{ body }}
    <template slot="primary">
      <button
          slot="primary"
          class="TURN-LEADS-OFF-BUTTON"
          selenium="modal-off-leads"
          @click.prevent="track('primary')"
      >Pause Now</button>
    </template>
    <template slot="secondary">
      <button
          slot="secondary"
          class="GOT-IT-BUTTON"
          @click.prevent="track('secondary')"
      >Got it</button>
    </template>
  </confirmation-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import ConfirmationModal from './ConfirmationModal';

export default {
  name: 'busy-pass-education-modal',
  components: {
    ConfirmationModal,
  },
  props: {
    isOpen: Boolean,
  },
  computed: {
    ...mapGetters('user', [
      'userId',
    ]),
    ...mapGetters('ui', [
      'passEducation',
    ]),
    header () {
      return this.passEducation.busyPassCount > 1 ? 'Pause leads to save points' : 'Need a break?';
    },
    body () {
      return this.passEducation.busyPassCount > 1 ? 'Don’t forget, even the leads you pass or ignore cost you points. Pause your leads when you’re busy and save your points!' : 'When you’re too busy for new jobs, you can pause your leads to save your points.';
    },
  },
  methods: {
    track (eventName) {
      this.$events.$emit(this.$events.PRO_BUSY_JOB_REJECT, {
        mightTurnOffLeads: eventName === 'primary',
      });

      this.$emit(eventName);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .TURN-LEADS-OFF-BUTTON {
    @include button-primary;
    @include button-medium;
    display: flex;
    flex: 1 1 auto;
    margin-left: 1.5*$unit;
    font-weight: 600;
  }
  .GOT-IT-BUTTON {
    @include button-tertiary;
    @include button-medium;
    display: flex;
    flex: 1 1 auto;
    margin-left: 1.5*$unit;
    font-weight: 600;
  }
</style>
